export const SITE = {
  name: "Ad Neurone Digital",
  tagline: "Performance marketing that pays for itself.",
  phone: "+1 302 445 8089",
  phoneRaw: "+13024458089",
  whatsapp: "13024458089",
  whatsappMessage:
    "Hi Ad Neurone Digital! I want more leads and sales for my business. Can we talk?",
  email: "support@adneuronedigital.com",
  city: "Mumbai, India",
};

export const SERVICES = [
  "Performance Marketing (Meta & Google Ads)",
  "Lead Generation",
  "Social Media Handling",
  "Sales Funnel & Growth Support",
  "Not Sure Yet",
];

export const BUDGETS = [
  "Under ₹25,000",
  "₹25,000 – ₹50,000",
  "₹50,000 – ₹1,00,000",
  "₹1,00,000 – ₹5,00,000",
  "₹5,00,000+",
  "Not Sure Yet",
];

export const HERO_BENEFITS = [
  "Free 30-minute strategy call with a senior performance marketer",
  "Custom growth roadmap for your business within 48 hours",
  "No long-term lock-ins — we earn your business every month",
];

export const TRUST_ITEMS = [
  "Meta Business Partner",
  "Google Ads Certified",
  "3.8x Average ROAS",
  "₹12Cr+ Client Revenue",
  "50+ Campaigns Scaled",
  "64% Lower Cost Per Lead",
  "Real Estate · Clinics · E-com · Coaches",
];

export const SERVICE_CARDS = [
  {
    id: "performance-marketing",
    icon: "Target",
    title: "Performance Marketing",
    stat: "Avg. 3.8x ROAS",
    copy: "Meta & Google Ads managed end-to-end. We obsess over one number: your cost per qualified lead.",
  },
  {
    id: "lead-generation",
    icon: "Magnet",
    title: "Lead Generation",
    stat: "64% lower CPL",
    copy: "High-intent leads delivered straight to your phone — people already looking for what you sell.",
  },
  {
    id: "social-media",
    icon: "Share2",
    title: "Social Media Handling",
    stat: "3x engagement",
    copy: "Scroll-stopping content and consistent posting that builds trust before the first sales call.",
  },
  {
    id: "sales-growth",
    icon: "TrendingUp",
    title: "Sales Funnel & Growth",
    stat: "2.4x close rate",
    copy: "Landing pages, follow-up systems and sales support that convert more of the leads you already get.",
  },
];

export const PROBLEMS = [
  "Budget disappears every month, leads don't pick up the phone",
  "Agency reports full of impressions and clicks — but no sales",
  "The same generic ads copied across every client they serve",
  "You chase them for updates. They vanish after the invoice",
];

export const SOLUTIONS = [
  "Every rupee tracked from click to lead to closed sale",
  "Weekly plain-English reports: spend, leads, cost per lead",
  "Custom strategy built on your market, margins and goals",
  "Direct WhatsApp access to the strategist running your ads",
];

export const PROCESS_STEPS = [
  {
    num: "01",
    title: "Deep Audit",
    copy: "We tear down your current ads, funnel and competitors to find exactly where money is leaking.",
  },
  {
    num: "02",
    title: "Precision Strategy",
    copy: "You get a custom growth plan — audiences, angles, budgets and revenue targets. No templates.",
  },
  {
    num: "03",
    title: "High-ROAS Launch",
    copy: "Campaigns go live with sharp creative, tight targeting and full conversion tracking from day one.",
  },
  {
    num: "04",
    title: "Optimize & Scale",
    copy: "We cut losers fast, double down on winners, and scale what works without blowing up your CPL.",
  },
];

export const STATS = [
  { value: 50, suffix: "+", decimals: 0, label: "Campaigns Scaled" },
  { value: 3.8, suffix: "x", decimals: 1, label: "Average Client ROAS" },
  { value: 64, suffix: "%", decimals: 0, label: "Lower Cost Per Lead" },
  { value: 12, suffix: "Cr+", decimals: 0, prefix: "₹", label: "Client Revenue Generated" },
];

export const TESTIMONIALS = [
  {
    name: "Rohan Mehta",
    role: "Founder, Mehta Realty",
    tag: "Real Estate",
    badge: "-52% Cost Per Lead",
    quote:
      "We went from 15 junk leads a week to 40+ genuine site-visit enquiries. Our cost per lead dropped by half in the very first month.",
    avatar:
      "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMGhlYWRzaG90JTIwcG9ydHJhaXQlMjBmb3VuZGVyJTIwZXhlY3V0aXZlfGVufDB8fHx8MTc5MTE4OTMxNnww&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Dr. Ananya Iyer",
    role: "Director, SmileCare Dental Studio",
    tag: "Clinic",
    badge: "2x Appointments",
    quote:
      "Appointment bookings doubled in 60 days. They explain everything in plain language and actually answer the phone when I call.",
    avatar:
      "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMGhlYWRzaG90JTIwcG9ydHJhaXQlMjBmb3VuZGVyJTIwZXhlY3V0aXZlfGVufDB8fHx8MTc5MTE4OTMxNnww&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Sneha Kulkarni",
    role: "Founder, UrbanNest Decor",
    tag: "E-commerce",
    badge: "5.2x ROAS",
    quote:
      "Our Diwali campaign hit 5.2x ROAS. This is the first agency that treats my ad budget like it's their own money.",
    avatar:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMGhlYWRzaG90JTIwcG9ydHJhaXQlMjBmb3VuZGVyJTIwZXhlY3V0aXZlfGVufDB8fHx8MTc5MTE4OTMxNnww&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Arjun Malhotra",
    role: "Fitness Coach & Nutrition Expert",
    tag: "Coach",
    badge: "Fully Booked in 21 Days",
    quote:
      "I filled every 1-on-1 coaching slot in three weeks. The funnel they built sells my program while I'm busy training clients.",
    avatar:
      "https://images.unsplash.com/photo-1758691737644-ef8be18256c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBvcnRyYWl0JTIwaGVhZHNob3QlMjBmb3VuZGVyJTIwY29ycG9yYXRlfGVufDB8fHx8MTc5MTE4OTMwNXww&ixlib=rb-4.1.0&q=85",
  },
];

export const FAQS = [
  {
    q: "How much do your services cost?",
    a: "Management fees depend on your ad spend and scope of work. It starts with a free strategy call — after understanding your goals, we send a custom quote. No hidden charges, ever.",
  },
  {
    q: "How fast will I start seeing leads?",
    a: "Campaigns go live within 5–7 working days of onboarding. Most clients see quality leads within the first 2 weeks; strong, stable returns typically build over 60–90 days of continuous optimization.",
  },
  {
    q: "What's the minimum ad budget I need?",
    a: "We recommend at least ₹25,000/month per platform so Meta and Google's algorithms have enough data to optimize. If your budget isn't ready, we'll tell you honestly and suggest what to do first.",
  },
  {
    q: "How will I know what's happening with my money?",
    a: "Weekly reports in plain English — spend, leads, cost per lead, and sales. Plus a live dashboard you can check anytime, and a direct WhatsApp line to the strategist running your account.",
  },
  {
    q: "Do you lock clients into long contracts?",
    a: "No. We work month-to-month. If we don't deliver value, you're free to walk away — that keeps us sharp and keeps you in control.",
  },
  {
    q: "Which platforms do you run ads on?",
    a: "Meta (Facebook & Instagram) and Google (Search, Display, YouTube). We pick platforms based on where your customers actually spend time — not where it's easiest for us.",
  },
];

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -90 });
  else el.scrollIntoView({ behavior: "smooth" });
}
